export default __webpack_public_path__ + "static/media/logo_tecda.cca51866.png";